import SaveTwoToneIcon from "@mui/icons-material/SaveTwoTone";
import {
  Backdrop,
  Button,
  Divider,
  Grid,
  FormControl,
  Fade,
  List,
  ListItem,
  ListItemIcon,
  Modal,
  TextField,
} from "@mui/material";
import { Dimension } from "../../TypesAndConstants/types";
import Drawer from "@mui/material/Drawer";
import makeStyles from "@mui/styles/makeStyles";
import axios from "axios";
import Draggable from "react-draggable";
import React, { memo, useContext, useState, useEffect } from "react";
import "../../../App.css";
import { Context } from "../../Context/context";
import { useSizingContext } from "../../Context/SizingContext";
import { baseStyle } from "../../theme";
import { ColorTheme, menuID } from "../../TypesAndConstants/const";
import { MenuActions } from "../../TypesAndConstants/types";
import BrushSettingFactory from "../Controls/BrushSideSettings/BrushSettingSideFactory";
import getIconComponent from "../SketchUtilities/getBrushIcons";
import MovieMaker from "../SketchUtilities/MovieMaker/MovieMakerComponent";
import SimpleDialog from "./SimpleDialog";
import { THREE_INST } from "../SketchUtilities/Three/threeSingleton";
import { NavBar } from "./BrushMenus/TopMenu/NavBar";
import ColorSideBarModal from "./Cards/ColorSelectSideBar/ColorSideBarModal";
import { ToolbarContainer } from "./ToolbarContainer";
import ReactNativeMessageHandler from "../ReactNativeMessageHandler";
import { MenuContext } from "./BrushMenus/TopMenu/TopMenuContext";

const drawerWidth = 200;
const useStyles = makeStyles((theme) => ({
  drawer: {
    width: drawerWidth,
    elevation: 4,
    flexShrink: 0,
    topRightBorderRadius: "150px",
  },
  drawerPaper: {
    overflowX: "hidden",
    minWidth: "150px",
    fontSize: "20px",
    height: "fit-content",
    maxHeight: "75%",
    marginTop: "15vh",
    padding: "5px",
    width: "15%",
  },
  brushHandles: {
    position: "fixed",
    zIndex: 100000,
    borderRadius: "20px",
    padding: "5px",
    border: `2px solid ${ColorTheme.primaryText}`,
    background: ColorTheme.secondaryBackground,
    top: "17h",
  },
  drawerPaperTablet: {
    overflowX: "hidden",
    fontSize: "20px",
    height: "fit-content",
    maxHeight: "84vh",
    overFlow: "auto",
    marginTop: "15vh",
    padding: "5px",
  },
  colorBar: {
    fontFamily: "'amatic', cursive",
    width: "10%",
    minWidth: "150px",
    fontSize: "20px",
    borderTopRightRadius: "20px",
    borderBottomRightRadius: "30px",
    height: "fit-content",
    marginTop: "20vh",
  },
  items: {
    fontFamily: "'amatic', cursive",
    fontSize: "28px",
  },
  list: {},
  newCanvas: {
    background: "white",
    cursor: "pointer",
    padding: "5px",
    borderTop: "0px",
    borderLeft: "0px",
    borderTopLeftRadius: "0px",
    borderTopRightRadius: "0px",
    borderBottomLeftRadius: "0px",
    borderBottomRightRadius: "5px",
    display: "flex",
    position: "absolute",
    top: "0%",
    left: "0",
    zIndex: 2000,
    backgroundColor: ColorTheme.secondaryBackground,
    fontSize: "40px",
  },
  mobileHistoryContainer: {
    display: "none",
  },
  historyItem: {
    display: "flex",
    height: "44px",
    margin: "0 auto",
    marginTop: "3%",
    fontSize: "25px",
    textAlign: "center",
    fontFamily: "'amatic', cursive",
  },
  historyImage: {
    height: "50px",
  },
}));

export const navItems: MenuActions[] = [
  "pen",
  "spring",
  "wipe",
  "growshrink",
  "shape",
];

const Controls = function (props:any) {
  const {
    state: {
      currentActiveMenu,
      colorBarIsCollapsed,
      brushbarIsCollapsed,
      brushType,
      userSessionData,
      dimensions
    },
    dispatch,
  } = useContext(Context);

  const {state:{ screenWidth, screenHeight, isPortrait, isMobile } } = useSizingContext();
  const { state: localState } = useContext(MenuContext);
  const [isSmallPreview, setSmallPreview] = useState<boolean>(false);
  const [isModalOpen, setModalOpen] = useState<boolean>(false);
  const [storedImage, setStoredImage] = useState<string | undefined>();
  const [imageTitle, setTitle] = useState<string>("");
  const [isHovered, setHovered] = useState<boolean>(false);
  const [openReplay, setOpenReplay] = useState<boolean>(false);
  const [showSuccessSave, setShowSuccessSave] = useState<boolean>(false);
  const [openSpeedDial, setOpenSpeedDial] = useState<boolean>(false);

  const three = THREE_INST.getInst();

  const undoIcon = require("../../../Assets/undo.svg");

  const classes = useStyles();
  const baseStyles = baseStyle({});

  const closeCard = () => {
    dispatch({ type: "set_active_menu", value: "none" });
  };

  const onNewCanvas = () => {
    dispatch({ type: "set_active_menu", value: "new" });
  };

  const undo = () => {
    dispatch({ type: "undo", value: undefined });
  };

  const storeImageForSaveOpenModal = React.useCallback(() => {
    setStoredImage(three.obj.getDownloadImage());
    setModalOpen(true);
  }, []);

  // useInterval(() => {
  //   setHistoryCounter(three.obj.backgroundImages.length);
  // }, 500);


  const postImage = (fileName: string | null, cb: (res: any) => void) => {
    axios
      .post(
        "https://www.artthread.org/Splash2/SaveImage.php",
        JSON.stringify({
          b64: three.obj.getDownloadImage(),
          filename: `${userSessionData.session!.session}_${imageTitle}.png`,
        }),
        {
          headers: {
            "Access-Control-Allow-Origin": "*",
            "Content-Type": "application/json",
          },
        }
      )
      .then((res) => {
        cb(res);
      });
  };

  const getFileName = (): string | null => {
    const fileName = (document.querySelector("#standard-basic") as HTMLInputElement )?.value ?? null
    return fileName;
  }

  const downloadImage = (fileName: string | null = null ) => {
    if (storedImage) {
      if (window.isMobileSplash && window.ReactNativeWebView) {
        ReactNativeMessageHandler.postMessage(
          {
            image: three.obj.getDownloadImage(),
            title: imageTitle,
          },
          "downloadImage"
        );

        return;
      }
      var link = document.createElement("a");
      link.download = `${ fileName ?? imageTitle}.png`;
      link.href = storedImage;
      link.click();
    }
  };

  const saveSuccesfulComponent = () => {
    return (
      <div
        style={{
          padding: "5px 0px 0px 5px",
          display: showSuccessSave ? "block" : "none",
        }}
      >
        <Button
          fullWidth
          variant="contained"
          color="primary"
          onClick={() => {
            setModalOpen(false);
            setShowSuccessSave(false);
            setTitle("");
          }}
          style={{ marginBottom: "4px" }}
        >
          Continue?
        </Button>
        <Button
          fullWidth
          variant="contained"
          color="primary"
          onClick={() => {
            setModalOpen(false);
            dispatch({ type: "set_active_menu", value: "new" });
            setShowSuccessSave(false);
            setTitle("");
          }}
        >
          Start New Canvas?
        </Button>
      </div>
    );
  };

  const saveImageDialog = () => {
    const buttons = !showSuccessSave
      ? {
          actionCB: () => {
            let title = getFileName();
            downloadImage(title);
            setTitle("");
            setModalOpen(false);
            setOpenSpeedDial(false);
            closeCard();
          },
          actionTitle: "Download",
          thirdActionTitle: "Save To Gallery!",
          thirdActionCB: () => {
            let title = getFileName();
            setModalOpen(false);
            setOpenSpeedDial(false);
            const image = three.obj.getDownloadImage();
            if (image) {
              postImage(title, () => {
                setTimeout(function () {
                  window.location.replace(
                    "https://www.artthread.org/addart.php"
                  );
                }, 250);
              });
            }
          },
        }
      : {
          actionCB: () => {
            setModalOpen(false);
            setOpenSpeedDial(false);
            dispatch({ type: "set_active_menu", value: "new" });
            setShowSuccessSave(false);
            setTitle("");
          },
          actionTitle: "Start New Canvas?",
          thirdActionTitle: "Continue?",
          thirdActionCB: () => {
            setOpenSpeedDial(false);
            setModalOpen(false);
            setShowSuccessSave(false);
            setTitle("");
          },
        };

    return SimpleDialog({
      open: isModalOpen,
      title: "Your art needs a title!",
      content: saveImageDialogContent(),
      actionTitle: buttons.actionTitle,
      actionCB: buttons.actionCB,
      handleClose: () => {
        setModalOpen(false);
        setShowSuccessSave(false);
        setTitle("");
        setOpenSpeedDial(false);
      },
      thirdActionTitle: buttons.thirdActionTitle,
      thirdActionCB: buttons.thirdActionCB,
    });
  };

  const saveImageDialogContent = () => {
    return (
      <Grid container spacing={3} style={{ marginTop: "2px" }}>
        <Grid item xs={12}>
          <FormControl>
            <TextField
              autoFocus={true}
              id="standard-basic"
              onChange={(event) => {
                setTitle((event.target as any).value);
              }}
              label="Title"
              value={imageTitle}
              style={{ margin: "10px" }}
            />
          </FormControl>
        </Grid>
      </Grid>
    );
  };

  const saveImageModal = () => {
    return (
      <Modal
        id={"loadScreen"}
        open={isModalOpen}
        onClose={() => {
          setModalOpen(false);
          setShowSuccessSave(false);
          setTitle("");
        }}
        closeAfterTransition
        BackdropComponent={Backdrop}
        BackdropProps={{
          timeout: 50,
        }}
      >
        <Fade in={isModalOpen}>
          <div
            style={{
              position: "absolute",
              fontFamily: "'amatic', cursive",
              width: "60%",
              backgroundColor: "white",
              border: "1.5px solid",
              borderRadius: "5px",
              top: "50%",
              left: "50%",
              padding: "10px",
              transform: "translate(-50%,-50%)",
            }}
          >
            <h2 id="transition-modal-title">Your art needs a title!</h2>
            <TextField
              id="standard-basic"
              onChange={(event) => {
                setTitle((event.target as any).value);
              }}
              label="Title"
              value={imageTitle}
              style={{ margin: "10px"}}
            />
            {saveSuccesfulComponent()}
            {imageTitle != "" && (
              <div
                style={{
                  padding: "5px 0px 0px 5px",
                  display: showSuccessSave ? "none" : "block",
                }}
              >
                {/* {three.obj.backgroundImages.length > 4 && (
                  <Button
                    variant="contained"
                    fullWidth
                    color="primary"
                    onClick={() => {
                      setOpenReplay(!openReplay);
                    }}
                  >
                    Replay!
                  </Button>
                )} */}
                {userSessionData.session &&
                  userSessionData.session.response_code !== 404 && (
                    <Button
                      variant="contained"
                      color="primary"
                      fullWidth
                      style={{ marginBottom: "5px" }}
                      onClick={() => {
                        const image = three.obj.getDownloadImage();
                        const title = getFileName()
                        if (image) {
                          postImage(title, () => {
                            setTimeout(function () {
                              setModalOpen(false);
                              window.location.replace(
                                "https://www.artthread.org/addart.php"
                              );
                            }, 250);
                          });
                        }
                      }}
                    >
                      Save To Gallery!
                    </Button>
                  )}
                <Button
                  variant="contained"
                  fullWidth
                  color="primary"
                  onClick={() => {
                    downloadImage();
                    setShowSuccessSave(true);
                  }}
                >
                  Download Image!
                </Button>
              </div>
            )}
          </div>
        </Fade>
      </Modal>
    );
  };

  const dockedSideBar = () => {
    return (
      <div
        className={`${classes.list} brushDockedContainer`}
        style={{
          fontFamily: "carter",
          fontSize: "larger",
          fontWeight: "bolder",
          height: "50vh",
          fontVariant: "petite-caps",
          padding: " 15px 0px",
        }}
      >
        <div className={`${classes.brushHandles}`}>
          <p style={{ margin: 0 }}>Brush</p>
          <p style={{ margin: 0 }}>Handles</p>
        </div>
        <div
          className={"iconContainer"}
          style={{
            backgroundColor: ColorTheme.contrastBackground,
            boxShadow:
              "inset 0 1px 1px #fff, inset 0 -1px 1px #aaa, 0 2px 4px -3px #666",
          }}
        >
          {navItems.map((i: MenuActions) => (
            <div key={i} style={{ width: "100%", margin: "20px 0px" }}>
              <div style={{ margin: "0 auto" }}>{getIconComponent(i)}</div>
            </div>
          ))}
        </div>
      </div>
    );
  };

  const dockedSideBarContent = () => {
    return !isHovered && <>{dockedSideBar()}</>;
  };


  /* this function resize preview size if overwraps with canvas */
  function updatePreviewSize( dimensions:Dimension, screenWidth:number, screenHeight: number ) {
    const normalPreviewSize = 100;
    const menubarHeight = 50;
    let rotated = ( isMobile && isPortrait )
    var width = rotated? dimensions.height : dimensions.width;
    var height = rotated? dimensions.width : dimensions.height;
    var normal = true;
    if( ( screenHeight  - height ) < ( menubarHeight + normalPreviewSize ) ){
      normal = false; 
    } else if ( ( screenWidth - width ) / 2 < normalPreviewSize ) {
      normal = false;
    }
    console.info('normal = ' + normal )
    setSmallPreview( !normal );
  }

  useEffect(() => {
    three.obj.mountPreview();
    three.obj.setPreviewTexture(three.obj.initialBrush);
    three.obj.setAlphaTexture(three.obj.initialBrush);
    dispatch({ type: "set_active_brush", value: three.obj.initialBrush });
  }, []);

  useEffect(()=> {
    if( brushbarIsCollapsed ) {
      console.info("Preview: main")
      three.obj.mountPreview();
    } else {
      console.info("Preview: modal")
      three.obj.mountPreviewMobile();
    }

  }, [brushbarIsCollapsed])

  useEffect(()=> {
    updatePreviewSize( dimensions, screenWidth, screenHeight )
  }, [dimensions, screenWidth, screenHeight ])

  return (
    <>
      <div
        id={"previewCanvas"}
        className={` ${baseStyles.previewCanvasContainer} ${baseStyles.background}`}
        style={{
          display: localState.displayPreview ? "block" : "none",
          position: "fixed",
          width: "100px",
          height: "100px",
          background: "white",
          top: "10px",
          right: "10px",
          transformOrigin: 'top right',
          transform: isSmallPreview? "scale(0.5)":"scale(1.0)"
        }}
      />
      {saveImageDialog()}
      <ColorSideBarModal display={ "inherit"} />
      { NavBar({
          openBrush: () => {
            three.obj.isMobileMenuOpen =
              brushbarIsCollapsed || colorBarIsCollapsed;
            setTimeout(() => {
              three.obj.mountPreviewMobile();
            }, 1);
            dispatch({
              type: "set_brushbar_collapsed",
              value: !brushbarIsCollapsed,
            });
          },
          openColors: () => {
            three.obj.isMobileMenuOpen =
              brushbarIsCollapsed || colorBarIsCollapsed;
            dispatch({
              type: "set_colorbar_collapsed",
              value: !colorBarIsCollapsed,
            });
          },
          undo: () => {
            undo();
          },
          redo: () => {},
          saveImage: () => {
            storeImageForSaveOpenModal();
            setOpenSpeedDial(false);
          },
          newCanvas: () => {
            onNewCanvas();
          },
          setOpenSpeedDial: (val) => {
            console.info("set open speed dial")
            setOpenSpeedDial(val);
          },
          openSpeedDial: openSpeedDial,
        })}
      <ToolbarContainer
        activeMenu={currentActiveMenu}
        closeCard={closeCard}
        dispatch={dispatch}
      />

    </>
  );
};

export default memo(Controls);
